"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getISOStringDate = getISOStringDate;
function getISOStringDate(date) {
  if (!date) {
    return date;
  }
  return date.toISOString();
}